/* eslint-disable no-useless-escape */
import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import parsePhoneNumber from 'libphonenumber-js';

import { COUNTRY_CODES } from '~src/constants';

import CountryCodeInput from './country-code-input';

import withControlled from '../form/with-controlled';

import './style.scss';

export const PhoneInput = ({
  value,
  className,
  placeholder = '',
  icon,
  errors,
  isInvalid,
  inputRef = useRef(),
  disabled = false,
  label,
  defaultCountry = 'NL',
  onChange = () => {},

  ...props
}) => {
  const handleFocus = () => {
    setTimeout(() => inputRef.current.select(), 0);
  };

  const getNumberFromValue = (v = '') => {
    if (!v) {
      return '';
    }
    const phoneNumber = parsePhoneNumber(v);
    return phoneNumber?.nationalNumber || '';
  };

  const getIsoCodeFromValue = (v = '') => {
    if (!v) {
      return defaultCountry;
    }
    const phoneNumber = parsePhoneNumber(v);
    return phoneNumber?.country || defaultCountry;
  };

  const [number, setNumber] = useState(getNumberFromValue(value));
  const [isoCode, setIsoCode] = useState(getIsoCodeFromValue(value));

  const handleIsoCodeChange = (v) => {
    const { dialCode } = COUNTRY_CODES.find((c) => c.isoCode === v);
    setIsoCode(v);
    onChange(`${dialCode}${number}`);
  };

  const handleNumberChange = (v) => {
    const { dialCode } = COUNTRY_CODES.find((c) => c.isoCode === isoCode);
    setNumber(v);
    onChange(`${dialCode}${v}`);
  };

  return (
    <div
      className={classNames('c-form__phone-input', {
        'c-form__input--invalid': isInvalid,
        [className]: !!className,
      })}
    >
      {label && <div className="c-form__label">{label}</div>}

      <div className="c-phone-input">
        <CountryCodeInput
          className="c-phone-input__select"
          value={isoCode}
          onChange={(code) => {
            handleIsoCodeChange(code);
          }}
        />

        <input
          className={classNames('c-input c-phone-input__input', {
            'c-phone-input__input--with-icon': !!icon,
            'c-phone-input__input--invalid': isInvalid,
          })}
          value={number}
          placeholder={placeholder}
          disabled={disabled}
          ref={inputRef}
          onChange={(ev) => {
            handleNumberChange(ev.target.value);
          }}
          onFocus={handleFocus}
          label={label}
          {...props}
        />
        {icon && <div className="c-input__icon">{icon}</div>}
      </div>

      {errors && <div className="c-input__error">{errors.message}</div>}
    </div>
  );
};

export const PhoneInputControlled = withControlled(PhoneInput);
